import { render } from "./addressDisplay.vue?vue&type=template&id=c964f584&scoped=true&ts=true"
import script from "./addressDisplay.vue?vue&type=script&lang=ts"
export * from "./addressDisplay.vue?vue&type=script&lang=ts"

import "./addressDisplay.vue?vue&type=style&index=0&id=c964f584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c964f584"],['__file',"src/components/addressDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c964f584"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c964f584', __exports__)) {
    api.reload('c964f584', __exports__)
  }
  
  module.hot.accept("./addressDisplay.vue?vue&type=template&id=c964f584&scoped=true&ts=true", () => {
    api.rerender('c964f584', render)
  })

}


export default __exports__